// ©2024 Austin App House. All rights reserved.
import React from 'react';

const SelectDropDownElement = ({
  isCurrentPageSelected,
  selectCurrentPage,
}) => (
  // <div className="position-relative">
  //   <div className="flex-box">
    <label className="check_btn">
      <input
        className="float-right"
        type="checkbox"
        checked={isCurrentPageSelected}
        label="Select"
        id="selectDropbox"
        onChange={selectCurrentPage}
      />
    </label>
  //   </div>
  // </div>
);

export default SelectDropDownElement;
